//'use strict';
import React, { useRef, useState } from "react";
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import {axiosEH} from './common/functions'
import jwtUser from '../jwtUser';
import './mediaDevices-getUserMedia-polyfill'
import './install'
import './record.css'

function Record(props) {
  // 1. 1st-level vars
  const [statusMsg, setStatusMsg] = useState('');
  const recordEl = useRef(null)
  const stopEl = useRef(null)
  const submitEl = useRef(null)
  const soundClipsEl = useRef(null)

  try {
    let evtTgt, url
    //let WIDTH, HEIGHT
    const options = {
      audioBitsPerSecond: 16000,
      //mimeType : 'audio/ogg'
    }
    const location = useLocation().state.taskId; // obj [buid, TPID]
    const user = jwtUser(); // get user token
    /* 
    dictionary MediaRecorderOptions {
    DOMString mimeType;
    unsigned long audioBitsPerSecond;
    unsigned long videoBitsPerSecond;
    unsigned long bitsPerSecond;
    };
    */

    let wordArr;

    // 2. url
    if (location === undefined) {
      url = process.env.REACT_APP_BASEURL + '/usertasks/0';    // default value
    } else {
      url = process.env.REACT_APP_BASEURL + `/usertasks/${location}`;
    }

    /* get tp: {} for err, [] for ok
      wordArr[0] for report file name w/o extension
    */
    async function getTestPaper() {
      axios.get(url, { headers: { 'x-access-token': user['x-access-token'] } })
        .then(res => {
          //console.log('res.data:', res.data); // ['demot-214-M1 2019-1-1-PA-demot','cat,dog']
          if ( Array.isArray(res.data)) {  // ok []
            res.data = res.data.filter(function(e){return e});  // 2nd remove all empty arr el
            wordArr = [res.data[0], ...res.data[1].split(',')];
            flashcardsThree();
            //flashcardsOne();
          } else {
            setStatusMsg(res.data.info);
          }
        })
        .catch(err => { 
          setStatusMsg(axiosEH(err)); 
        })
    }

    const getDelay = word => {
      // const delay = 1000 + 150 * word.length;  // sometimes cut off words
      const delay = 500 + 160 * word.length;
      //console.log("word,delay:", word,delay);
      return delay
    }

    /* timeout async f() */
    const timeoutAsync = (finished, delay, word) => {

      // 2. time out
      const timerID = setTimeout(() => {
        //console.timeEnd(word);
        // 21
        document.getElementById("wordInput").value = word;

        // 22. end/stop chk
        if (finished || stopEl.current.disabled) {
          clearTimeout(timerID);
          stopEl.current.onclick();
          document.getElementById("wordInput").value = "";
          return;
        }
      }, delay);
    };

    /* 3+ delays for all words, working */
    const flashcardsThree = () => {
      // 1.
      let delaySum = 0, finished = false;
      document.getElementById("wordInput").value = wordArr[1];

      // 2. loop of timeOut f()
      for (let i = 2; i <= wordArr.length; i++) {
        //21. manually clicked stop btn
        /*
        if (stopEl.current.disabled) {
          document.getElementById("wordInput").value = '';
          return;
        } */

        // 21. get delay
        let delay = getDelay(wordArr[i - 1])
        if (i == (wordArr.length)) { // last word
          delay += 300; finished = true;
        }

        // 22. delay sum
        delaySum += delay;
        //console.time(wordArr[i])

        // 23. call timeOut f()
        timeoutAsync(finished, delaySum, wordArr[i]);
      }
    }

    /* not used: 1-delay for all words, working */
    const flashcardsOne = () => {
      //
      let i = 2, delay = 1700;
      document.getElementById("wordInput").value = wordArr[1];

      // 2
      var timerID = setInterval(function () {
        // 21. end/stop chk
        if (i >= wordArr.length || stopEl.current.disabled) {
          clearInterval(timerID);
          stopEl.current.onclick();
          document.getElementById("wordInput").value = "";
          return;
        }

        //22. else 
        document.getElementById("wordInput").value = wordArr[i];
        i++;
      }, delay);
    }

    // disable stop button while not recording
    if (stopEl && stopEl.current) stopEl.current.disabled = true
    // click disabled button 1st caused app crash

    // visualiser setup - create web audio api context and canvas
    if (!window.AudioContext) return

    //main block for doing the audio recording

    if (navigator.mediaDevices.getUserMedia) {  // get media ok
      console.log('getUserMedia supported.')

      var constraints = { audio: true }
      var chunks = []

      var onSuccess = function (stream) {
        //var mediaRecorder = new MediaRecorder(stream);
        var mediaRecorder = new MediaRecorder(stream, options);

        recordEl.current.onclick = async function () {
          // audio clip exist, then remind & ret
          const nodeList = document.querySelectorAll(`article > p`)
          const nodeLen = nodeList.length
          if (nodeLen >= 1) {
            alert("Press Redo button to redo the task")
            return;
          }

          mediaRecorder.start();
          console.log('recorder start');  //mediaRecorder.state = recording
          recordEl.current.style.background = 'red'

          stopEl.current.disabled = false
          recordEl.current.disabled = true;
          getTestPaper();
        }

        stopEl.current.onclick = function () {
          if (mediaRecorder.state === `inactive`) return
          mediaRecorder.stop()
          console.log('recorder stopped');
          recordEl.current.style.background = ''
          recordEl.current.style.color = ''
          stopEl.current.disabled = true
          recordEl.current.disabled = false
          //window.location.reload();
        }

        mediaRecorder.onstop = function (e) {    // stop btn click handler
          //console.log('data available after MediaRecorder.stop() called.')

          var clipContainer = document.createElement('article')
          var clipAudio = document.createElement('audio')
          var clipLabel = document.createElement('p')
          var clipScore = document.createElement('input');
          var clipRedo = document.createElement('button')

          clipContainer.classList.add('clip');
          clipAudio.setAttribute('controls', '');

          clipLabel.className = 'button is-success  is-normal mx-3 has-text-centered';
          clipLabel.style = "width: 100%";  // % x 500
          clipLabel.textContent = `${wordArr[0]}`;
          // w/o ext: has-text-centered, has-text-right, has-text-left

          //document.getElementById("clipScore").readOnly = true;  
          clipScore.className = "input is-success  is-normal has-text-centered";
          clipScore.type = `text`; //clipScore.readonly = true;                
          clipScore.placeholder = "Score";
          //clipScore.style = "width: 78%";
          clipScore.style = "width: fit-content";
          //clipScore.value = "";
          //clipScore.id = `clipScore`;

          clipRedo.textContent = 'Redo'
          clipRedo.className = 'button is-normal is-warning is-square';
          //clipRedo.className = 'button is-warning  is-normal is-rounded';
          clipRedo.style = "width: 20%;";

          clipContainer.appendChild(clipAudio)
          // note the order of the 3 buttons
          clipContainer.appendChild(clipLabel);
          clipContainer.appendChild(clipScore);
          clipContainer.appendChild(clipRedo);
          soundClipsEl.current.appendChild(clipContainer);

          const blob = new Blob(chunks, { type: 'audio/ogg; codecs=opus' });  // v
          chunks = [];
          var audioURL = window.URL.createObjectURL(blob)
          clipAudio.src = audioURL;
          clipAudio.title = wordArr[0] + '.ogg';

          // --- btns click handlers
          clipRedo.onclick = function (e) {
            //evtTgt = e.target
            //evtTgt.parentNode.parentNode.removeChild(evtTgt.parentNode)
            window.location.reload();
          }

          clipLabel.onclick = function () {
            return; // clip name ready only
            var existingName = clipLabel.textContent
            var newClipName = prompt(
              'Enter a new name for your sound clip?'
            )
            if (newClipName === null) {
              clipLabel.textContent = existingName
            } else {
              clipLabel.textContent = newClipName
            }
          }

          submitEl.current.onclick = function () {
            //submitEl.onclick = function(e) {  //x
            console.log(`Submit button clicked`);

            evtTgt = e.target
            const nodeList = document.querySelectorAll(`article > p`)
            const nodeLen = nodeList.length
            if (nodeLen < 1) return;    // no clips, all deleted

            let fd = new FormData();
            fd.append('upl', blob, nodeList[nodeLen - 1].innerHTML);
            //fd.append('upl', blob);
            const request = new XMLHttpRequest();
            url = process.env.REACT_APP_BASEURL + '/upload';
            //request.open("POST", "/upload");  //ok
            request.open("POST", url);
            request.setRequestHeader('x-access-token', user['x-access-token']);
            request.send(fd);
            //request.send({text: "hello"});

            clipScore.value = "Scoring";
            request.onreadystatechange = function () {
              if (request.readyState == 4 && request.status == 200) {
                console.log(request.responseText);  // 2. for silent audio
                clipScore.value = request.responseText;
                //clipScore.value = JSON.parse (request.responseText);
                //clipScore.value = "score: "+JSON.parse (request.responseText);

                // all 4 btns disabled
                recordEl.current.disabled = true
                submitEl.current.disabled = true
                stopEl.current.disabled = true
                clipRedo.disabled = true;
              }
            }
          }
        }   // stop btn click handler: end

        mediaRecorder.ondataavailable = function (e) {
          chunks.push(e.data)
        }
      }

      var onError = function (err) {
        console.log(err)
      }

      navigator.mediaDevices
        .getUserMedia(constraints)
        .then(onSuccess, onError)
    } else {
      console.log('getUserMedia not supported on your browser!')
    }
  }
  catch (err) {
    console.log(err.message);
    setStatusMsg(err.message);
  }

  return (
    <div className="mx-5" >
      <label className="label  is-normal has-text-success">Press Record button to start</label>
      <p className="buttons is-normal">
        <button className="button is-success is-rounded is-active" ref={recordEl}>
          <span className="icon">
            <i className="fas fa-microphone"></i>
          </span>
          <span>Record</span>
        </button>

        <button className="button is-warning is-rounded is-hovered" ref={stopEl}>
          <span className="icon">
            <i className="far fa-stop-circle"></i>
          </span>
          <span>Stop</span>
        </button>

        <button className="button is-success is-rounded" ref={submitEl}>
          <span className="icon">
            <i className="fas fa-cloud-upload-alt"></i>
          </span>
          <span>Submit</span>
        </button>
      </p>

      <input className="input is-success" type="text" id="wordInput" placeholder="Pronounce the word/phrase"></input>
      <section className="sound-clips" ref={soundClipsEl}> </section>
      <br></br>
      <label className="label has-text-success">{statusMsg}</label>
    </div>
  )
}

export default Record